import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Empty from '../empty/Empty'

export default ({
    error,
}: {
    error: any
}) => {
    const { t } = useTranslation()

    const errorMessage = useCallback(() => {
        switch (error.status) {
            case 400: return t('apiError.badRequest.message')
            case 401: return t('apiError.unauthorized.message')
            case 403: return t('apiError.forbidden.message')
            case 404: return t('apiError.notFound.message')
            case 409: return t('apiError.conflict.message')
            case 500: return t('apiError.internalServerError.message')
            default: return t('apiError.unknown.message')
        }
    }, [error, t])

    return <>
        <Empty
            lottie='error'
            title={t('apiError.label')}
            description={errorMessage()}
        />
    </>
}
